import styled from 'styled-components'

const DocumentboardSvgImage = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 200" fill="none">
		<g filter="url(#filter0_d_8_979)">
			<path
				d="M9.99228 34.8529C9.36506 32.2496 10.904 29.68 13.4795 28.9464C25.2161 25.6034 55.4677 16.9886 56.5268 16.7055C57.1369 16.5424 89.22 8.49821 101.502 5.41899C104.131 4.75994 106.781 6.26356 107.507 8.87464C113.741 31.289 140.424 127.465 140.223 130.849C139.995 134.681 47.3564 159.824 42.8951 156.866C38.9506 154.251 15.3966 57.2842 9.99228 34.8529Z"
				fill="#DCDEEB"
			/>
			<path
				d="M97.7041 9.41433L17.7267 30.7933C16.3882 31.1511 15.6867 32.8691 16.1598 34.6306L46.1425 146.262C46.6156 148.023 48.0842 149.161 49.4227 148.803L129.4 127.424C130.739 127.066 131.44 125.348 130.967 123.587L100.984 11.9559C100.511 10.1944 99.0426 9.05653 97.7041 9.41433Z"
				fill="white"
			/>
			<path
				d="M61.4043 38.5236L28.2266 47.3924C27.1161 47.6893 26.4475 48.7923 26.7332 49.8561C27.0189 50.9199 28.1508 51.5416 29.2613 51.2448L62.439 42.376C63.5496 42.0791 64.2182 40.9761 63.9325 39.9123C63.6467 38.8485 62.5149 38.2268 61.4043 38.5236Z"
				fill="#4F5BD5"
			/>
			<path
				d="M84.325 42.0308L30.8579 56.3232C29.6276 56.6521 28.8618 57.7811 29.1475 58.8449C29.4332 59.9087 30.6622 60.5044 31.8926 60.1755L85.3597 45.8831C86.5901 45.5542 87.3559 44.4252 87.0702 43.3614C86.7845 42.2977 85.5554 41.7019 84.325 42.0308Z"
				fill="#4F5BD5"
			/>
			<path
				d="M96.9483 89.0293L43.4811 103.322C42.2508 103.651 41.485 104.78 41.7707 105.843C42.0564 106.907 43.2855 107.503 44.5158 107.174L97.9829 92.8816C99.2133 92.5527 99.9791 91.4237 99.6934 90.3599C99.4077 89.2961 98.1786 88.7004 96.9483 89.0293Z"
				fill="#4F5BD5"
			/>
			<path
				d="M75.6438 55.0866L33.335 66.3962C32.2223 66.6937 31.552 67.7972 31.8377 68.861C32.1234 69.9248 33.257 70.546 34.3697 70.2486L76.6785 58.9389C77.7912 58.6415 78.4616 57.538 78.1758 56.4742C77.8901 55.4104 76.7565 54.7892 75.6438 55.0866Z"
				fill="#4F5BD5"
			/>
			<path
				d="M88.7819 101.947L46.4731 113.257C45.3604 113.555 44.69 114.658 44.9758 115.722C45.2615 116.786 46.3951 117.407 47.5078 117.109L89.8166 105.8C90.9292 105.502 91.5997 104.399 91.3139 103.335C91.0282 102.271 89.8946 101.65 88.7819 101.947Z"
				fill="#4F5BD5"
			/>
			<path
				d="M101.943 57.6905L36.835 75.0948C35.1227 75.5525 33.9662 76.786 34.252 77.8497C34.5377 78.9135 36.1574 79.4049 37.8697 78.9471L102.978 61.5428C104.69 61.0851 105.847 59.8517 105.561 58.7879C105.276 57.7241 103.656 57.2328 101.943 57.6905Z"
				fill="#4F5BD5"
			/>
			<path
				d="M104.358 66.6793L39.2493 84.0836C37.537 84.5413 36.3805 85.7747 36.6662 86.8385C36.9519 87.9023 38.5717 88.3936 40.284 87.9359L105.392 70.5316C107.105 70.0739 108.261 68.8405 107.976 67.7767C107.69 66.7129 106.07 66.2216 104.358 66.6793Z"
				fill="#4F5BD5"
			/>
			<path
				d="M106.772 75.6681L41.6636 93.0724C39.9513 93.5301 38.7948 94.7635 39.0805 95.8273C39.3662 96.8911 40.9859 97.3824 42.6982 96.9247L107.807 79.5204C109.519 79.0627 110.676 77.8293 110.39 76.7655C110.104 75.7017 108.484 75.2104 106.772 75.6681Z"
				fill="#4F5BD5"
			/>
			<path
				d="M71.6387 35.7879L68.0632 36.7436C67.2734 36.9548 66.8647 37.9883 67.1504 39.0521C67.4361 40.1159 68.308 40.8071 69.0979 40.596L72.6734 39.6402C73.4633 39.4291 73.872 38.3955 73.5862 37.3317C73.3005 36.2679 72.4286 35.5767 71.6387 35.7879Z"
				fill="#4F5BD5"
			/>
			<path
				d="M107.013 86.3387L103.438 87.2945C102.648 87.5056 102.239 88.5392 102.525 89.603C102.811 90.6667 103.683 91.358 104.473 91.1468L108.048 90.1911C108.838 89.9799 109.247 88.9464 108.961 87.8826C108.675 86.8188 107.803 86.1276 107.013 86.3387Z"
				fill="#4F5BD5"
			/>
			<path
				d="M41.1591 19.6879C41.1217 19.4247 41.2807 19.1826 41.538 19.1129C43.9898 18.4485 55.8317 15.2397 56.2042 15.1402C56.4176 15.0831 68.7632 11.826 71.3758 11.1368C71.6507 11.0643 71.9246 11.2188 72.0095 11.4895C72.5541 13.2264 74.3687 19.0971 74.1063 19.3795C73.7981 19.7112 44.4948 27.5694 43.3447 27.6025C42.3571 27.6309 41.4076 21.4378 41.1591 19.6879Z"
				fill="#2D3D9A"
			/>
			<path
				d="M68.1634 55.696C68.2329 53.0214 70.3824 50.9402 73.0576 50.8967C85.2571 50.6981 116.724 50.1877 117.82 50.1877C118.452 50.1877 151.52 50.7015 164.187 50.8986C166.899 50.9408 169.071 53.0817 169.095 55.7941C169.302 79.0674 170.123 178.836 169.051 182.053C167.837 185.695 71.8323 186.061 68.2903 182.053C65.1584 178.508 67.5643 78.7483 68.1634 55.696Z"
				fill="#DCDEEB"
			/>
			<path
				d="M159.486 53.7771H76.6873C75.3016 53.7771 74.1783 55.2555 74.1783 57.0791V172.648C74.1783 174.472 75.3016 175.95 76.6873 175.95L108.375 178.976C114.658 179.576 120.983 179.58 127.267 178.987L159.486 175.95C160.872 175.95 161.995 174.472 161.995 172.648V57.0791C161.995 55.2555 160.872 53.7771 159.486 53.7771Z"
				fill="white"
			/>
			<path
				d="M102.202 49.1005C102.235 48.8366 102.451 48.6438 102.718 48.6429C105.258 48.6342 117.529 48.5924 117.915 48.5924C118.136 48.5924 130.906 48.634 133.608 48.6428C133.892 48.6438 134.117 48.8638 134.129 49.1472C134.204 50.9655 134.434 57.1047 134.107 57.3097C133.723 57.5505 103.38 57.5747 102.26 57.3097C101.299 57.0821 101.988 50.855 102.202 49.1005Z"
				fill="#2D3D9A"
			/>
		</g>
		<g clipPath="url(#clip0_8_979)">
			<path
				d="M127.6 92.8657L123.281 88.5567C122.486 87.764 122.486 86.4836 123.281 85.6909C124.075 84.8982 125.359 84.8982 126.154 85.6909L129.026 88.5567L136.238 81.3616C137.033 80.5689 138.317 80.5689 139.111 81.3616C139.906 82.1543 139.906 83.4348 139.111 84.2275L130.473 92.8453C129.678 93.6583 128.395 93.6583 127.6 92.8657ZM115.722 86.1787H101.461C100.34 86.1787 99.4233 87.0933 99.4233 88.2112C99.4233 89.3291 100.34 90.2437 101.461 90.2437H115.722C116.843 90.2437 117.76 89.3291 117.76 88.2112C117.76 87.0933 116.843 86.1787 115.722 86.1787ZM136.687 97.7844C135.892 96.9917 134.609 96.9917 133.814 97.7844L129.984 101.606L126.154 97.7844C125.359 96.9917 124.075 96.9917 123.281 97.7844C122.486 98.577 122.486 99.8575 123.281 100.65L127.111 104.471L123.281 108.292C122.486 109.085 122.486 110.366 123.281 111.158C124.075 111.951 125.359 111.951 126.154 111.158L129.984 107.337L133.814 111.158C134.609 111.951 135.892 111.951 136.687 111.158C137.481 110.366 137.481 109.085 136.687 108.292L132.856 104.471L136.687 100.65C137.481 99.8575 137.481 98.577 136.687 97.7844ZM115.722 102.439H101.461C100.34 102.439 99.4233 103.353 99.4233 104.471C99.4233 105.589 100.34 106.504 101.461 106.504H115.722C116.843 106.504 117.76 105.589 117.76 104.471C117.76 103.353 116.843 102.439 115.722 102.439Z"
				fill="#565CD4"
			/>
		</g>
		<g clipPath="url(#clip1_8_979)">
			<path
				d="M127.6 133.11L123.281 128.801C122.486 128.008 122.486 126.728 123.281 125.935C124.075 125.142 125.359 125.142 126.154 125.935L129.026 128.801L136.238 121.606C137.033 120.813 138.317 120.813 139.111 121.606C139.906 122.398 139.906 123.679 139.111 124.472L130.473 133.089C129.678 133.902 128.395 133.902 127.6 133.11ZM115.722 126.423H101.461C100.34 126.423 99.4233 127.337 99.4233 128.455C99.4233 129.573 100.34 130.488 101.461 130.488H115.722C116.843 130.488 117.76 129.573 117.76 128.455C117.76 127.337 116.843 126.423 115.722 126.423ZM136.687 138.029C135.892 137.236 134.609 137.236 133.814 138.029L129.984 141.85L126.154 138.029C125.359 137.236 124.075 137.236 123.281 138.029C122.486 138.821 122.486 140.102 123.281 140.894L127.111 144.715L123.281 148.537C122.486 149.329 122.486 150.61 123.281 151.402C124.075 152.195 125.359 152.195 126.154 151.402L129.984 147.581L133.814 151.402C134.609 152.195 135.892 152.195 136.687 151.402C137.481 150.61 137.481 149.329 136.687 148.537L132.856 144.715L136.687 140.894C137.481 140.102 137.481 138.821 136.687 138.029ZM115.722 142.683H101.461C100.34 142.683 99.4233 143.598 99.4233 144.715C99.4233 145.833 100.34 146.748 101.461 146.748H115.722C116.843 146.748 117.76 145.833 117.76 144.715C117.76 143.598 116.843 142.683 115.722 142.683Z"
				fill="#565CD4"
			/>
		</g>
		<defs>
			<filter
				id="filter0_d_8_979"
				x="1.85242"
				y="1.26416"
				width="175.738"
				height="195.659"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.207843 0 0 0 0 0.25098 0 0 0 0 0.321569 0 0 0 0.15 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_8_979"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_8_979"
					result="shape"
				/>
			</filter>
			<clipPath id="clip0_8_979">
				<rect
					width="48.8967"
					height="48.7805"
					fill="white"
					transform="translate(95.3486 71.9512)"
				/>
			</clipPath>
			<clipPath id="clip1_8_979">
				<rect
					width="48.8967"
					height="48.7805"
					fill="white"
					transform="translate(95.3486 112.195)"
				/>
			</clipPath>
		</defs>
	</svg>
)

const StyledDocumentboardImageWrapper = styled.div`
	margin-bottom: 31px;
	margin-inline: auto;
	width: 120px;
	height: 135px;
`

export const DocumentboardSVGComponent = (): JSX.Element => {
	return (
		<StyledDocumentboardImageWrapper>
			<DocumentboardSvgImage />
		</StyledDocumentboardImageWrapper>
	)
}
